import isString from 'lodash/isString'
import type { MouseEventHandler, ReactNode } from 'react'
import React from 'react'
import { Icon } from '../Icon'
import { ShowIf } from '../ShowIf'

export type WidgetProps = {
  value?: ReactNode
  description?: ReactNode
  bgColor?:
    | 'bg-primary'
    | 'bg-success'
    | 'bg-info'
    | 'bg-warning'
    | 'bg-danger'
    | 'bg-muted'
    | 'bg-primary-subtle'
    | 'bg-success-subtle'
    | 'bg-info-subtle'
    | 'bg-warning-subtle'
    | 'bg-danger-subtle'
    | 'bg-dark'
    | 'bg-light'
  icon?: string
  onClick?: MouseEventHandler<HTMLAnchorElement>
  children?: ReactNode
}
/**
 *  The common Widget
 */
export const Widget = ({ value, description, bgColor = 'bg-muted', icon, onClick, children }: WidgetProps) => {
  //if value is just string then enveloped if with h4, else make it an element
  if (isString(value)) {
    value = <h2>{value}</h2>
  }
  if (isString(description)) {
    description = <small>{description}</small>
  }
  const content = (
    <div className={`widget ${bgColor} p-0`}>
      <div className="row p-1">
        <ShowIf condition={!!icon}>
          <div className="col-xs-2">
            <Icon name={icon} className="fa-4x" />
          </div>
        </ShowIf>
        <div className={`text-end ${icon ? 'col-xs-10' : 'col-xs-12'} `}>
          {value}
          {description}
        </div>
      </div>

      <div className="row p-w-m">{children}</div>
    </div>
  )
  if (onClick) {
    return (
      <a href="/" onClick={(e) => onClick(e)}>
        {content}
      </a>
    )
  } else {
    return content
  }
}
